import api from "./api";
const getAllBank = () => {
  return api.get("/api/get-banks");
};
const getUserBanks = (size = 10, page = 0) => {
  return api.get(`/api/get-all-customer-bank?size=${size}&page=${page}`);
};
const forgetPassword = (email) => {
  return api.get("/api/forgot-password", {
    params: {
      emailAddress: email,
    },
  });
};
const forgetPin = (email) => {
  return api.get("/api/forgot-pin", {
    params: {
      emailAddress: email,
    },
  });
};
const getTransactionHistory = () => {
  return api.get("/api/transaction-history");
};
const refreshToken = () => {
  return api.get("/api/refresh-token");
};
const verifyBankAccount = (accNum, bankCode) => {
  return api.get(
    `/api/verify-accountNumber?accountNumber=${accNum}&bankCode=${bankCode}`,
  );
};
const getNextOfKin = () => {
  return api.get("/api/get-next-of-kin");
};
const getWalletBalance = () => {
  return api.get("/api/get-balance");
};
const getAllProject = (
  location,
  maxPrice,
  minPrice,
  projectName,
  projectType,
) => {
  return api.get(
    `/api/all-projects?location=${location}&maxPrice=${maxPrice}&minPrice=${minPrice}&projectName=${projectName}&projectType=${projectType}`,
  );
};
const getAllProperty = (
  location,
  maxPrice,
  minPrice,
  projectName,
  projectType,
) => {
  //return api.get( `/api/return-all-properties`);
  return api.get(
    `/api/all-properties?maxPrice=${maxPrice}&minPrice=${minPrice}`,
  );
};
const getSingleProject = (id, status) => {
  return api.get(`/api/property-id?propertyId=${id}`);
};
const getSingleInvestProject = (id, status) => {
  return api.get(`/api/project-id?projectId=${id}`);
};
const getUserInvestment = (status) => {
  return api.get(`/api/project-id`);
};
const getVerifyPayment = (ref) => {
  return api.get(`/api/verify-wallet?reference=${ref}`);
};
const getVerifySavingPayment = (ref) => {
  return api.get(`/api/verify-plan?reference=${ref}`);
};
const walletHistory = (walletId) => {
  return api.get(`/api/get-recent-transaction?walletId=${walletId}`);
};
const savings = (status) => {
  return api.get(`/api/plan-id`);
};
const investmentHistory = (id) => {
  return api.get(`/api/project-id?projectId=${id}&status=recursive`);
};
const getSavingPlanDetails = (id, status) => {
  return api.get(`/api/plan-id?planId=${id}&savingStatus=${status}`);
};
const getNotifications = (page = 0, size = 10) => {
  return api.get(
    `/api/notification/get-notification?page=${page}&size=${size}`,
  );
};
const getUnreadNotificationCount = () => {
  return api.get(`/api/notification/unread-count`);
};
const readAllNotifications = () => {
  return api.get(`/api/notification/read-all`);
};
const readSingleNotification = (id) => {
  return api.get(`/api/notification/${id}/read`);
};
const getSavedProduct = (size = 10, page = 0) => {
  return api.get(`/api/get-property-buy-later?size=${size}&page=${page}`);
};

const getProjectBuyLater = (size = 10, page = 0) => {
  return api.get(`/api/get-project-buy-later?size=${size}&page=${page}`);
};

const getDataPlan = (network) => {
  return api.get(`/apibill/data-plan?network=${network}`);
};

const getElectricity = () => {
  return api.get(`/bills/all-billers`);
};
const verifyFunding = (reference) => {
  return api.get(
    `/api/topupcliq-verify-wallet?deviceId=$deviceId&reference=${reference}`,
  );
};
const smeDataList = () => {
  return api.get(`/api/sme-plan`);
};
const getCable = () => {
  return api.get(`/bills/cabletv-providers`);
};

const userGetProperty = (size = 20, page = 0) => {
  return api.get("/api/user-get-property", {
    params: {
      size,
      page,
    },
  });
};

const userGetSavingsWalletBalance = () => {
  return api.get("/api/user-get-savings-wallet-balance");
};

const getAllSavingsPlanByUser = () => {
  return api.get("/api/get-all-savings-plan-by-user");
};

const getRecentTransaction = (walletId) => {
  return api.get(`/api/get-recent-transaction?walletId=${walletId}`);
};

const getRentals = async (
  propertyType = "HOUSE",
  size = 10,
  page = 0,
  active = true,
) => {
  const response = await api.get(
    `/api/get-rentals?PropertyType=${propertyType}&size=${size}&page=${page}&active=${active}`,
  );
  return response;
};
const getRentalsByUserAndStatus = (status) => {
  return api.get(`/api/get-rentals-by-user-and-status?RentedStatus=${status}`);
};

const getActiveRentals = (status = "ONGOING") => {
  return api.get(
    `/api/get-apartment-class-by-user-and-status?RentedStatus=${status}`,
  );
};
// list of apartment classes available for an apartment
const getApartmentClassByApartmentId = (apartmentId, size = 10, page = 0) => {
  return api.get(
    `/api/get-apartment-class-by-apartment-id?size=${size}&page=${page}&apartmentId=${apartmentId}`,
  );
};
// details of an apartment class
const getApartmentClassById = (apartmentClassId) => {
  return api.get(
    `/api/get-apartment-class-by-id?apartmentClassId=${apartmentClassId}`,
  );
};

const getApartmentBuyLater = (page = 0, size = 10) => {
  return api.get(`/api/get-apartment-buy-later?page=${page}&size=${size}`);
};

const getTopInvestment = () => {
  return api.get(`/api/get-top-investment`);
};

const getUserProfile = () => {
  return api.get("/api/get-user-profile");
};

const getActiveProperty = () => {
  return api.get("/api/get-active-property-invested");
};

const getActiveInvestment = (propertyInvestorId) => {
  return api.get(
    `/api/get-active-investment?propertyInvestorId=${propertyInvestorId}`,
  );
};

const getPropertyInvestmentBalance = () => {
  return api.get("/api/investments/tiles");
};
const getListing = (size = 20, page = 0) => {
  return api.get("/api/get-all-project", {
    params: {
      size,
      page,
    },
  });
};
const getListingById = (propertyId) => {
  return api.get(`/api/get-listing-by-id?projectId=${propertyId}`);
};

const getUserKycLevel = () => {
  return api.get("/api/get-user-kyc-level");
};

const getActiveListings = () => {
  return api.get("/api/get-active-listing?projectStatus=ACTIVE&size=20&page=0");
};

const getActiveProjectTransactions = (walletId) => {
  return api.get(`/api/get-active-project-transactions?walletId=${walletId}`);
};

const getProjectPhases = (projectId) => {
  return api.get(
    `/api/get-all-project-phase-by-project?projectId=${projectId}`,
  );
};

const getPropertyPhases = (propertyId) => {
  return api.get(
    `/api/get-all-property-phase-by-property?propertyId=${propertyId}`,
  );
};

// const getSavedRentals = (size = 10, page = 0) => {
//   return api.get(`/api/get-saved-rentals?size=${size}&page=${page}`);
// };

const getSalesTransactionHistory = (propertyId) => {
  return api.get(
    propertyId
      ? `/api/get-sales-transaction-history?propertyId=${propertyId}`
      : `/api/get-sales-transaction-history`,
  );
};

const getRentalsTransactionHistory = (propertyId) => {
  return api.get(
    propertyId
      ? `/api/get-rentals-transaction-history?propertyId=${propertyId}`
      : `/api/get-rentals-transaction-history`,
  );
};

const getInvestmentById = (propertyId) => {
  return api.get(`/api/get-investment-by-id?propertyId=${propertyId}`);
};

const getServices = {
  getInvestmentById,
  getPropertyInvestmentBalance,
  getUserProfile,
  getTopInvestment,
  getAllBank,
  verifyBankAccount,
  getUserBanks,
  getTransactionHistory,
  refreshToken,
  getNextOfKin,
  getWalletBalance,
  getAllProject,
  getAllProperty,
  getSingleProject,
  getSingleInvestProject,
  getUserInvestment,
  getVerifyPayment,
  getVerifySavingPayment,
  walletHistory,
  savings,
  investmentHistory,
  getSavingPlanDetails,
  getNotifications,
  getUnreadNotificationCount,
  readAllNotifications,
  readSingleNotification,
  getSavedProduct,
  getProjectBuyLater,
  getDataPlan,
  getElectricity,
  verifyFunding,
  smeDataList,
  getCable,
  forgetPassword,
  forgetPin,
  userGetProperty,
  getRentals,
  userGetSavingsWalletBalance,
  getAllSavingsPlanByUser,
  getRecentTransaction,
  getRentalsByUserAndStatus,
  getActiveRentals,
  getActiveProperty,
  getActiveInvestment,
  getListing,
  getListingById,
  getUserKycLevel,
  getActiveListings,
  getActiveProjectTransactions,
  getApartmentClassByApartmentId,
  getApartmentClassById,
  getApartmentBuyLater,
  getProjectPhases,
  getPropertyPhases,
  getAllPropertyPhaseByProperty: getPropertyPhases,
  getSalesTransactionHistory,
  getRentalsTransactionHistory,
  // getSavedRentals,
};

export default getServices;
